import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DepartmentInfo, InsuranceCompanySeed } from '../../models/domain/InsuranceCompanySeed';
import { CaseSearchFilter } from '../../../app-cases/models/case-search-filter';
import { SCConfig } from '../../../sc-config/constant/sc-config.constant';
import { Subject, takeUntil } from 'rxjs';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentCustomDateAdapter } from '../date-time-picker/custom.date.adapter';
export const MY_FORMATS = {
    parse: {
        dateInput: 'DD.MM.YYYY'
    },
    display: {
        dateInput: 'DD.MM.YYYY',
        monthYearLabel: 'YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'YYYY'
    }
};

@Component({
    selector: 'app-advance-search-filter',
    templateUrl: './app-advance-search-filter.component.html',
    styleUrls: ['./app-advance-search-filter.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentCustomDateAdapter,
            deps: [MAT_DATE_LOCALE]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ],
    standalone: false
})
export class AppAdvanceSearchFilterComponent implements OnInit, OnDestroy {
    private readonly destroy$: Subject<boolean> = new Subject<boolean>();

    @Input() formGroup;
    @Input() insuranceCompanies;
    @Input() inspectorUserList: any;
    @Input() backOfficeUserList: any;
    @Input() currentRole: string;
    @Input() userInfo: any;
    @Output() searchFilterChanged = new EventEmitter<CaseSearchFilter>();
    @Output() searchFilterClosed = new EventEmitter();
    @Output() onClearFilterForm = new EventEmitter();

    @Input() departmentList = new Array<DepartmentInfo>();
    statusList = SCConfig.CaseStatusList;
    documentProcessingStatusList: string[] = SCConfig.DocumentProcessingStatusList;
    scConfigLanguages = SCConfig.Languages;

    constructor() {}

    public ngOnInit(): void {
        this.formGroup
            .get('InsuranceCompany')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((insuranceCompany: InsuranceCompanySeed) => {
                if (insuranceCompany) {
                    this.departmentList = insuranceCompany.DepartmentInfoList;
                    this.formGroup.get('Department').setValue(null);
                    this.formGroup.get('Department').enable();
                } else {
                    this.formGroup.get('Department').setValue(null);
                    this.formGroup.get('Department').disable();
                    this.departmentList = [];
                }
            });

        this.formGroup
            .get('CaseStatus')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe(status => {
                if (
                    status.Key == SCConfig.CaseStatus.QUALITY_CHECK.Key &&
                    this.currentRole == SCConfig.CurrentRole.Inspector
                ) {
                    this.formGroup.get('InspectorUserId').setValue(this.userInfo ? this.userInfo.UserId : '');
                }
            });
        this.selectedDepartment();
    }

    public onClear() {
        this.onClearForm();
        this.searchFilterChanged.next(new CaseSearchFilter());
        this.onClose();
    }

    public onClearForm() {
        this.onClearFilterForm.emit(null);
    }

    public onClose() {
        this.searchFilterClosed.next(true);
    }

    public applyFilter() {
        this.searchFilterChanged.next(this.formGroup.getRawValue());
        this.onClose();
    }

    public selectedDepartment() {
        if (this.formGroup.get('InsuranceCompany').value) {
            this.departmentList = this.formGroup.get('InsuranceCompany').value.DepartmentInfoList;
            this.formGroup.get('Department')?.enable();
        } else {
            this.formGroup.get('Department')?.disable();
        }
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
